export const DEFAULT_US_ADDRESS = {
  city: 'New York',
  state: 'NY',
  zip: '10001',
} as const

export const DEFAULT_US_COORDINATES = {
  lat: 40.7128,
  lon: -74.006,
} as const
